var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row match-height" }, [
      _c(
        "div",
        { staticClass: "col-lg-4 col-md-12 d-flex align-self-stretch" },
        [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-content" }, [
              _c("div", { staticClass: "card-body d-flex flex-column" }, [
                _c("h4", { staticClass: "card-title info" }, [
                  _vm._v("Recharger les définitions")
                ]),
                _vm._m(0),
                _c("p", { staticClass: "card-text" }, [
                  _vm._v(" Vous ne serez pas déconnecté de MercuDyn. ")
                ]),
                _c(
                  "button",
                  {
                    staticClass: "btn mt-auto btn-primary btn-block",
                    on: {
                      click: function($event) {
                        return _vm.rechargerDefinitions()
                      }
                    }
                  },
                  [
                    _c("i", {
                      ref: "defs",
                      staticClass: "fas fa-eraser",
                      staticStyle: { "margin-right": "10px" }
                    }),
                    _vm._v(" Recharger les définitions")
                  ]
                )
              ])
            ])
          ])
        ]
      ),
      _c("div", { staticClass: "col-lg-4 col-md-12" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-content" }, [
            _c("div", { staticClass: "card-body d-flex flex-column" }, [
              _c("h4", { staticClass: "card-title info" }, [
                _vm._v("Recharger les mercuriales")
              ]),
              _c("p", { staticClass: "card-text" }, [
                _vm._v(
                  " Permet d'actualiser les grilles tarifaires ainsi que les liens avec les produits et ingrédients de MercuDyn. "
                )
              ]),
              _c("p", { staticClass: "card-text" }, [
                _vm._v(" Vous ne serez pas déconnecté de MercuDyn. ")
              ]),
              _c(
                "button",
                {
                  staticClass: "btn mt-auto btn-primary btn-block",
                  on: {
                    click: function($event) {
                      return _vm.rechargerMercuriales()
                    }
                  }
                },
                [
                  _c("i", {
                    ref: "mercs",
                    staticClass: "fas fa-eraser",
                    staticStyle: { "margin-right": "10px" }
                  }),
                  _vm._v(" Recharger les mercuriales")
                ]
              )
            ])
          ])
        ])
      ]),
      _c("div", { staticClass: "col-lg-4 col-md-12" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-content" }, [
            _c("div", { staticClass: "card-body d-flex flex-column" }, [
              _c("h4", { staticClass: "card-title info" }, [
                _vm._v("Vider le cache")
              ]),
              _vm._m(1),
              _c("p", { staticClass: "card-text" }, [
                _vm._v(" Vous ne serez pas déconnecté de MercuDyn. ")
              ]),
              _c(
                "button",
                {
                  staticClass: "btn mt-auto btn-primary btn-block",
                  on: {
                    click: function($event) {
                      return _vm.nettoyerCache()
                    }
                  }
                },
                [
                  _c("i", {
                    ref: "cach",
                    staticClass: "fas fa-eraser",
                    staticStyle: { "margin-right": "10px" }
                  }),
                  _vm._v(" Vider le cache")
                ]
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "card-text" }, [
      _vm._v(
        " Permet de récupérer les définitions suite à une modification ou un ajout."
      ),
      _c("br"),
      _vm._v(" Exemple : "),
      _c("em", [_vm._v("catégorie de recette, composante menu...")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "card-text" }, [
      _vm._v(
        " Vider le cache du navigateur permet de rafraichir l'intégralité des données."
      ),
      _c("br"),
      _vm._v(" Action généralement réalisée sur demande du support technique. ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }